import{a as u}from"./chunk-RAAYCPUM.js";function a(...r){return u(o,r)}function o(r,t){let e=[];for(let n=r;n<t;n++)e.push(n);return e}export{a};
